let appConfig;
const setConfig = (config) => {
    appConfig = config;
};
export const getConfig = () => appConfig;
export default setConfig;
